export default "__VITE_ASSET__XbihyPzf__"